(function () {
  var root = document.querySelector('[data-sl21-ugc]');
  if (!root || root.dataset.sl21Bound === '1') return;
  root.dataset.sl21Bound = '1';
  var rows = root.querySelectorAll('.nh-sl21ugc__row');
  if (!rows.length) return;
  Array.prototype.forEach.call(rows, function (row) {
    var originals = Array.prototype.slice.call(row.children);
    originals.forEach(function (card) {
      var copy = card.cloneNode(true);
      copy.setAttribute('aria-hidden', 'true');
      row.appendChild(copy);
    });
    row.dataset.sl21Count = String(originals.length);
  });
  Array.prototype.forEach.call(rows, function (row) {
    var down = false, startX = 0, startScroll = 0, moved = false;
    row.addEventListener('pointerdown', function (e) {
      if (e.pointerType !== 'mouse') return;
      down = true; moved = false; startX = e.clientX; startScroll = row.scrollLeft;
    });
    row.addEventListener('pointermove', function (e) {
      if (!down) return;
      var d = e.clientX - startX;
      if (!moved && Math.abs(d) < 4) return;
      moved = true;
      row.classList.add('is-dragging');
      row.scrollLeft = startScroll - d;
      e.preventDefault();
    });
    var release = function () {
      if (!down) return;
      down = false;
      window.setTimeout(function () { row.classList.remove('is-dragging'); }, 0);
    };
    row.addEventListener('pointerup', release);
    row.addEventListener('pointerleave', release);
    row.addEventListener('pointercancel', release);
    row.addEventListener('dragstart', function (e) { e.preventDefault(); });
  });
  Array.prototype.forEach.call(root.querySelectorAll('.nh-sl21ugc__text'), function (p) {
    if (p.dataset.sl21More) return;
    p.dataset.sl21More = '1';
    var button = document.createElement('button');
    button.type = 'button';
    if (p.closest('[aria-hidden="true"]')) button.tabIndex = -1;
    button.className = 'nh-sl21ugc__more';
    button.textContent = 'Lire plus…';
    p.parentNode.insertBefore(button, p.nextSibling);
    var check = function () {
      if (!p.classList.contains('is-open') && p.scrollHeight > p.clientHeight + 2) button.classList.add('is-visible');
    };
    check();
    setTimeout(check, 500);
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(check);
    button.addEventListener('click', function (ev) {
      ev.stopPropagation();
      var open = p.classList.toggle('is-open');
      button.textContent = open ? 'Réduire' : 'Lire plus…';
    });
  });
  var reduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)');
  if (reduced && reduced.matches) return;
  var SPEED = 26;
  Array.prototype.forEach.call(rows, function (row) {
    var dir = parseInt(row.getAttribute('data-sl21-dir'), 10) || 1;
    var paused = false, loop = 0, visible = true, last = 0, lastWrite = -1, resumeAt = 0;
    function measure() {
      var firstClone = row.children[parseInt(row.dataset.sl21Count, 10)];
      var first = row.children[0];
      loop = (firstClone && first) ? (firstClone.offsetLeft - first.offsetLeft) : 0;
      if (dir < 0 && row.scrollLeft < 1 && loop > 0) row.scrollLeft = loop;
    }
    measure();
    window.addEventListener('resize', measure);
    if (window.ResizeObserver) new ResizeObserver(measure).observe(row);
    ['mouseenter', 'focusin', 'touchstart', 'pointerdown'].forEach(function (e) {
      row.addEventListener(e, function () { paused = true; }, { passive: true });
    });
    ['mouseleave', 'focusout', 'touchend', 'touchcancel'].forEach(function (e) {
      row.addEventListener(e, function () { paused = false; }, { passive: true });
    });
    document.addEventListener('visibilitychange', function () { paused = document.hidden; });
    if (window.IntersectionObserver) {
      new IntersectionObserver(function (entries) { visible = entries[0].isIntersecting; }, { rootMargin: '160px' }).observe(row);
    }
    var pos = row.scrollLeft || 0;
    row.addEventListener('scroll', function () {
      if (lastWrite < 0 || Math.abs(row.scrollLeft - lastWrite) > 2) {
        pos = row.scrollLeft;
        resumeAt = (window.performance && performance.now ? performance.now() : Date.now()) + 900;
      }
    }, { passive: true });
    function tick(ts) {
      if (!last) last = ts;
      var dt = ts - last;
      if (dt > 64) dt = 64;
      last = ts;
      if (!paused && visible && loop > 0 && ts >= resumeAt) {
        pos += dir * SPEED * dt / 1000;
        if (pos >= loop) pos -= loop;
        else if (pos <= 0) pos += loop;
        row.scrollLeft = pos;
        lastWrite = row.scrollLeft;
      }
      requestAnimationFrame(tick);
    }
    requestAnimationFrame(tick);
  });
})();
